module.exports = __webpack_public_path__ + "static/img/lg-ess-img-01@m.7626969.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/lg-ess-img-01@m.jpg
// module id = 45HL
// module chunks = 0